export const route = {
  login: '/login',
  profile: '/app/tabs/profile',
  access: '/app/tabs/accesses',
  open_gate: '/open-gate',
  offline: '/offline',
};
